import { Label } from "@/components/Base/Label";
import { EditSaveInput } from "@/components/Common/EditSaveInput";
import { Integrators, Shop } from "@/types/v2";
import { Description } from "@/components/Common/Description";
import { Logo } from "@/components/Admin/Logo";
import { useStore } from "@/stores/useStore";
import { shop as shopRepository } from "@/repositories/shop";
import { Button } from "@/components/Base/Button";
import { httpsCallables } from "@/repositories/httpsCallables";
import { useState } from "react";

export const ShopInfo = () => {
  const shopData = useStore((s) => s.shop);
  const shopLogoUrl = useStore((s) => s.logoUrl);
  const shopFirestoreId = useStore((s) => s.shopId);
  const { user } = useStore();
  const [loading, setLoading] = useState(false);

  const handleSave = (key: keyof Shop, newName: string) => {
    if (!shopData?.id) return;
    shopRepository.update(shopData.id, { [key]: newName });
  };

  const handleManageSubscription = () => {
    if (user?.stripeCustomerId) {
      setLoading(true);
      httpsCallables
        .createCustomerPortalSession({
          shopId: shopData?.id,
          returnUrl: window.location.href,
        })
        .then((result) => {
          window.location.href = result.data.url;
        })
        .finally(() => setLoading(false));
    }
  };

  if (!shopData || !shopFirestoreId) return null;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-row items-center justify-between">
        <Label className={"w-28"} htmlFor={"shopName"}>
          Shop Name:
        </Label>
        <EditSaveInput
          name={"shopName"}
          containerClassName="pl-4"
          value={shopData?.name}
          onSave={(value) => handleSave("name", value as string)}
        />
      </div>
      <div className="flex flex-row items-center justify-between">
        <Label className={"w-28"} htmlFor={"shopEmail"}>
          Shop Email:
        </Label>
        <EditSaveInput
          name={"shopEmail"}
          containerClassName="pl-4"
          value={shopData?.email}
          onSave={(value) => handleSave("email", value as string)}
        />
      </div>
      <div className="flex flex-row items-center justify-between">
        <Label className={"w-28"} htmlFor={"shopPhone"}>
          Shop Phone:
        </Label>
        <EditSaveInput
          name={"shopPhone"}
          containerClassName="pl-4"
          value={shopData?.phone}
          onSave={(value) => handleSave("phone", value as string)}
        />
      </div>
      <div className="flex flex-row items-center justify-between">
        <Label className={"w-28"} htmlFor={"shopWebsite"}>
          Shop Website:
        </Label>
        <EditSaveInput
          name={"shopWebsite"}
          containerClassName="pl-4"
          value={shopData?.website}
          onSave={(value) => handleSave("website", value as string)}
        />
      </div>
      <div className="flex flex-row items-center justify-between">
        <Label className={"w-28"}>Shop ID:</Label>
        <EditSaveInput
          containerClassName="pl-4"
          value={shopData?.shopId}
          onSave={() => {}}
          disabled={true}
        />
      </div>
      {shopData?.integration === Integrators.shopware && (
        <div className="flex flex-col gap-1">
          <div className="flex flex-row items-center justify-between">
            <Label className={"w-28"} htmlFor={"integrationSubdomain"}>
              Shop-Ware Subdomain:
            </Label>
            <EditSaveInput
              name={"integrationSubdomain"}
              containerClassName="pl-4"
              value={shopData?.integrationSubdomain}
              onSave={(value) =>
                handleSave("integrationSubdomain", value as string)
              }
              aria-describedby="integrationSubdomainDescription"
            />
          </div>

          <Description id="integrationSubdomainDescription" className="pl-8">
            Shop-Ware uses a subdomain in the urls for work orders. This often
            will be similar to your shop name.
          </Description>
        </div>
      )}
      <div className="flex flex-row items-center justify-between">
        <Label className={"w-28"}>Account Creation Date:</Label>
        <EditSaveInput
          containerClassName="pl-4"
          value={shopData?.createdOn}
          onSave={() => {}}
          disabled={true}
        />
      </div>
      <div className="flex flex-row items-center justify-between">
        <Label className={"w-28"}>Shop Logo:</Label>
        <Logo shopId={shopFirestoreId} logoUrl={shopLogoUrl} canBeChanged />
      </div>

      <div className="flex flex-row items-center justify-between">
        {shopData?.stripeCustomerId === user?.stripeCustomerId && (
          <Button
            variant={"accent"}
            onClick={handleManageSubscription}
            disabled={loading}
          >
            {loading ? "Contacting Stripe..." : "Manage Subscription"}
          </Button>
        )}
      </div>
    </div>
  );
};
